import { Injectable } from '@angular/core';
import { IAdapter } from '@drl/core/api/adapters/i-adapter';
import { CurrentUserAdapter } from '@drl/core/auth/adapters/current-user-adapter.service';
import * as moment from 'moment';

import { PatientCaregiver } from '../models/patient-caregiver.model';

@Injectable()
export class PatientCaregiverAdapter implements IAdapter<PatientCaregiver> {
  constructor(private readonly userAdapter: CurrentUserAdapter) { }

  adaptToModel(resp: any): PatientCaregiver {
    const patientCg: PatientCaregiver = new PatientCaregiver();
    if (resp) {
      patientCg.patient = Object.assign(
        {},
        resp,
        this.userAdapter.adaptToModel(resp),
      );
      if (resp.caregiver) {
        patientCg.careGiver = Object.assign(
          {},
          resp.caregiver,
          this.userAdapter.adaptToModel(resp.caregiver),
        );

        // Restore some values which are overridden by user adapter
        patientCg.careGiver.genderEnum = resp.caregiver && resp.caregiver.gender;
        patientCg.careGiver.statusEnum = resp.caregiver && resp.caregiver.status;
      }
      patientCg.patient.genderEnum = resp.gender;
      patientCg.patient.statusEnum = resp.status;

      // Update DOB
      if (patientCg.patient.dob) {
        console.log('Patient DOB:', patientCg.patient.dob);
        const currentMoment = moment();
        const dobMoment = moment(patientCg.patient.dob);
        patientCg.patient.age = currentMoment.diff(dobMoment, 'years');
      }
    }
    return patientCg;
  }
  // sonarignore:start
  adaptFromModel(data: PatientCaregiver): any {
    // Restore some values
    const dataToSend: any = Object.assign({}, data);
    dataToSend.patient.gender = data.patient.genderEnum
    dataToSend.patient.status = data.patient.statusEnum;
    delete dataToSend.patient.username;
    if (data.careGiver) {
      dataToSend.careGiver.gender = data.careGiver.genderEnum;
      dataToSend.careGiver.status = data.careGiver.statusEnum;
      delete dataToSend.careGiver.username;
      delete dataToSend.careGiver.genderEnum;
      if( dataToSend.careGiver.relationLc) {
        dataToSend.careGiver.relationLc = dataToSend.careGiver.relationLc;
      }
    }else{
      delete dataToSend.careGiver;
    }

    delete dataToSend.patient.genderEnum;
    delete dataToSend.patient.cancerTypeLc;
    if(dataToSend.patient?.relationLc)
    {
      delete dataToSend.patient.relationLc;

    }

    return dataToSend;
  }
  // sonarignore:end
}
